import React ,{useState,useEffect} from 'react';
import { Grid, Typography, Container } from '@mui/material';
import { keyframes } from '@mui/system';
import ProductCard from './ProductCard';
import data from '../data.json'; 




const animateText = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Product = () => {

const [products, setProducts] = useState([]);

useEffect(() => {
  
  setProducts(data.products);
}, []);
  return (
    <Container>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          animation: `${animateText} 2s ease-in-out`,
        }}
      >
        Our Products & Services
      </Typography>
      <Grid container spacing={4}>
        {products.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </Grid>
    </Container>
  );
};

export default Product;
